// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1147v","right":"styles_right__k8K2t"};